import ApplicationLoading from 'hcp/components/application-loading';

<template><ApplicationLoading /></template>
